export default function Scroll() {

    // шапка
    checkHeaderPadding();
    //checkSticky();
    //archorsScroll();
    window.addEventListener('resize', function () {
        checkHeaderPadding();
        //archorsScroll();
    })

    window.addEventListener('scroll', () => {
        //checkSticky();
    });

    function checkHeaderPadding() {


        let html = document.querySelector('html'),
            //header_contacts = document.querySelector('.header-contacts'),
            header = document.querySelector('.header');

  /*      if(window.screen.width < 1140){
            html.style.scrollPaddingTop = (header_contacts.offsetHeight + 10) + 'px';
            document.querySelectorAll(".sidebar").forEach(item => {
                item.style.top = header_contacts.offsetHeight + 'px';
                item.style.maxHeight = document.documentElement.clientHeight - (header_contacts.offsetHeight) + 'px';
            })
        }else{*/
            html.style.scrollPaddingTop = (header.offsetHeight + 10) + 'px';
            document.querySelectorAll(".sidebar").forEach(item => {
                item.style.top = header.offsetHeight + 'px';
                item.style.maxHeight = document.documentElement.clientHeight - (header.offsetHeight) + 'px';
            })
      /*  }*/



    }

    function checkSticky() {
        let header = document.querySelector('.header-navigation');
        if (window.scrollY >= 80) {
            header.classList.add('header-navigation--stick');
        } else {
            header.classList.remove('header-navigation--stick');
        }
    }


    // to top

    let to_top = document.querySelector(".to-top__button");

    to_top.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });

    })

    toTopStatus();
    document.addEventListener("scroll", () => {
        toTopStatus();
    });

    function toTopStatus() {
        let to_top = document.querySelector(".to-top__button");
        if (window.scrollY > 100) {
            to_top.style.visibility = "visible";
        } else {
            to_top.style.visibility = "hidden";
        }
    }

    function archorsScroll() {

        let navigation = document.querySelector('.navigation'),
            contacts = document.querySelector('.contacts');

        var topMenu = $("#anchors"),
            topMenuHeight = topMenu.outerHeight() + 15,
            // All list items
            menuItems = topMenu.find("a"),
            // Anchors corresponding to menu items
            scrollItems = menuItems.map(function () {
                var item = $($(this).attr("href"));
                if (item.length) {
                    return item;
                }
            });
        // Bind to scroll
        $(window).scroll(function () {
            // Get container scroll position
            var fromTop = $(this).scrollTop() + navigation.offsetHeight + contacts.offsetHeight + 10;

            // Get id of current scroll item
            var cur = scrollItems.map(function () {
                if ($(this).offset().top < fromTop)
                    return this;
            });
            // Get the id of the current element
            cur = cur[cur.length - 1];
            var id = cur && cur.length ? cur[0].id : "";
            // Set/remove active class
            menuItems
                .parent().removeClass("active")
                .end().filter("[href='#" + id + "']").parent().addClass("active");

            // .scrollIntoView()
        });

    }

}
